<div class="para-checklist" [class.expanded]="!isLoading && items.length > 0">
  <div class="para-checklist-inner">
    @if (items.length > 0) {
      <div class="para-checklist-header">
        <button
          mat-icon-button
          type="button"
          class="para-checklist-toggle"
          [attr.aria-label]="rowsVisible ? 'Collapse' : 'Expand'"
          (click)="toggleRowsVisible()"
        >
          <mat-icon>{{
            rowsVisible ? "expand_more" : "chevron_right"
          }}</mat-icon>
        </button>
        <span [class.has-selected]="hasAnyUnchecked()"
          >Detailed Requirement Screening{{ hasAnyUnchecked() ? "*" : "" }}</span
        >
      </div>
    }
    @if (rowsVisible) {
      @for (item of items; track item.node.id) {
        <div class="para-checklist-row">
          <mat-checkbox
            [checked]="item.selected"
            [disabled]="!editable"
            (change)="onToggle(item)"
          >
            <span [innerHTML]="item.node.name"></span>
          </mat-checkbox>
        </div>
      }
    }
  </div>
</div>
